import { render } from "./Login.vue?vue&type=template&id=08a406ac"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__

/* vue-cli-plugin-import-components */

import ConvertedToEmailNotice from "@/components/ConvertedToEmailNotice.vue";
import NotificationSuccess from "@/components/NotificationSuccess.vue";
import PasswordInput from "@/components/PasswordInput.vue";
import SignupMainContainer from "@/components/signup/SignupMainContainer.vue";
script.components = Object.assign({}, { ConvertedToEmailNotice, NotificationSuccess, PasswordInput, SignupMainContainer }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ConvertedToEmailNotice, NotificationSuccess, PasswordInput, SignupMainContainer }, script.__o.components);}